export default {"src":"/_next/static/media/fountain.7113180b.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};